import RGBA from '../Fonts/RGBA'

let debug = false;
let markPositions = false;

export default class Model {

  constructor(width, height, data) {

    this.zoom = 2;

    this.center = { x : 0, y : 0};

    this.width = width;
    this.height = height;

    this.x = 0;
    this.y = 0;
    this.dx = 0;
    this.dy = 0;

    this.needsRendering = true;
    this.needsPositioning = true;
    this.isAnimating = false;
    this.clearBeforePositioning = false;

    this.canvas = document.createElement('canvas');
    this.ctx = this.canvas.getContext('2d');

    this.ctx.__owner = this.constructor.name;
    this.ctx.__ownerObject = this;

    this.ctx.imageSmoothingEnabled = false;

    this.data = data;

    this.previousX = null;
    this.previousY = null;
    this.previousHidden = false;

    this.hidden = false;
    this.radius = 0;

  }

  hide(reason) {
    if (!this.hidden) {

      if (this.constructor.name === 'Person') {
        if (typeof reason === 'undefined') {
          reason = 'Unknown reason';
        }
        // console.log('Hiding ' + this.getName() + ' (' + reason + ')');
      }

      this.previousHidden = false;
      this.hidden = true;
      this.needsPositioning = true;
    }
  }

  show(reason) {
    if (this.hidden) {

      if (this.constructor.name === 'Person') {
        if (typeof reason === 'undefined') {
          reason = 'Unknown reason';
        }

        // console.log('Showing ' + this.getName() + ' (' + reason + ')');
      }


      this.previousHidden = true;
      this.hidden = false;
      this.needsPositioning = true;
    }
  }

  setScale(scale) {
    this.zoom = scale;
  }

  scale(size) {
    return this.coord(size * this.zoom);
  }

  unscale(size) {
    return this.coord(size / this.zoom);
  }

  getX() {
    return this.x;
  }

  getY() {
    return this.y;
  }

  getWidth() {
    return this.width;
  }

  getHeight() {
    return this.height;
  }


  coord(i) {
    // fast round up
    return (i + (i>0?0.5:-0.5)) << 0;
  }

  round(i) {
    // fast round
    return (i + (i>0?0.5:-0.5)) << 0;
  }

  set(prop, value) {
    if (this.data[prop] !== value) {
      this.data[prop] = value;
      this.needsRendering = true;
    }
  }

  draw(ctx) {

  }



  clear(ctx, gameX, gameY, gameWidth, gameHeight) {

    if (this.previousX === null) {
      return;
    }

    let x = this.scale(this.x - this.center.x) - gameX;
    let y = this.scale(this.y - this.center.y) - gameY;
    let width = this.scale(this.width);
    let height = this.scale(this.height);

    if (this.previousX + width < 0 || this.previousY + height < 0 || this.previousX > this.scale(gameWidth) && this.previousY > this.scale(gameHeight)) {
      return;
    }

    if (this.previousX !== x || this.previousY !== y) {

      // this.previousX, this.previousY, this.scale(this.width), this.scale(this.height)
      let boxes = [];

      // If boxes do not overlap, just clear the previous position
      if (x > this.previousX + width || x + width < this.previousX || y > this.previousY + height || y + height < this.previousY || width < 100) {

        ctx.clearRect(this.previousX - 1, this.previousY - 1, width + 2, height + 2);
        return;

      }


      // boxes collide, clear only changed parts

      // right
      boxes.push({
        x : x + width - this.radius,
        y : this.previousY,
        width : this.previousX + this.radius - x,
        height
      });

      // left
      boxes.push({
        x : this.previousX,
        y : this.previousY,
        width : x + this.radius - this.previousX,
        height
      });

      // bottom
      boxes.push({
        x : this.previousX,
        y : y + height - this.radius,
        width : width,
        height : this.previousY + this.radius - y
      });

      // top
      boxes.push({
        x : this.previousX,
        y : this.previousY,
        width : width,
        height : y + this.radius - this.previousY
      });


      if (debug) {
        ctx.beginPath();

        let i = boxes.length;
        while (i--) {
          let box = boxes[i];
          if (box.width > 0 && box.height > 0) {
            ctx.rect(box.x - 1, box.y - 1, box.width + 2, box.height + 2);

          }
        }

        ctx.fillStyle= (new RGBA(50)).random();
        ctx.fill();
        return;
      }


      let i = boxes.length;
      while (i--) {
        let box = boxes[i];
        if (box.width > 0 && box.height > 0) {
          ctx.clearRect(box.x - 1, box.y - 1, box.width + 2, box.height + 2);
        }
      }

    }

  }


  position(ctx, gameX, gameY, gameWidth, gameHeight, force) {


    this.doPosition(ctx, gameX, gameY, gameWidth, gameHeight, force);

  }


  doPosition(ctx, gameX, gameY, gameWidth, gameHeight, force) {

    let x = this.scale(this.x - this.center.x) - gameX;
    let y = this.scale(this.y - this.center.y) - gameY;

    if (x + this.scale(this.width) >= 0 && y + this.scale(this.height) >= 0 && x <= this.scale(gameWidth) && y <= this.scale(gameHeight)) {

      if (debug && this.constructor.name !== 'Fps') {

        ctx.beginPath();

        ctx.rect(x, y, this.scale(this.width), this.scale(this.height));
        ctx.strokeStyle = 'white';
        ctx.fillStyle = 'black';
        ctx.stroke();
        ctx.fill();


      }
      else{

        if (!this.hidden) {
          if (this.previousX !== x || this.previousY !== y || this.needsPositioning || force === true) {

            ctx.drawImage(this.canvas, Math.floor(x), Math.floor(y));

            if (markPositions) {
              ctx.beginPath();
              ctx.rect(Math.floor(x) + 20, Math.floor(y), 20,20);
              ctx.fillStyle = new RGBA().random();
              ctx.fill();
            }

          }
        }

      }
    }

    this.previousX = x;
    this.previousY = y;
    this.needsPositioning = false;


  }

  render(ctx, gameX, gameY, gameWidth, gameHeight) {

    let width = this.scale(this.width);
    let height = this.scale(this.height);

    if (this.canvas.width !== width || this.canvas.height !== height) {
      this.canvas.width = this.scale(this.width);
      this.canvas.height = this.scale(this.height);
    }

    this.ctx.save();
    this.draw(this.ctx, gameX, gameY, gameWidth, gameHeight);
    this.ctx.restore();

    if (markPositions) {
      this.ctx.beginPath();
      this.ctx.rect(0, 0, 20, 20);
      this.ctx.fillStyle = new RGBA().random();
      this.ctx.fill();
    }

    this.needsRendering = false;
    this.needsPositioning = true;

  }

  drawOutline(ctx) {

    ctx.lineWidth = 1;
    ctx.strokeStyle = '#cc0000';
    ctx.beginPath();
    ctx.rect(1,1, this.scale(this.getWidth()) - 2, this.scale(this.getHeight()) - 2);
    ctx.stroke();
    ctx.closePath();

  }

  hover(x, y) {
    return false;
  }

  click(x, y) {
    // empty
  }

  mark() {

    this.ctx.beginPath();
    this.ctx.rect(0,0,10,10);
    this.ctx.fillStyle = (new RGBA()).random();
    this.ctx.fill();

  }

  garbageCollect() {

    if (this.ctx) {
      this.ctx.width = 1;
      this.ctx.height = 1;
    }
    if (this.canvas) {
      this.canvas.width = 1;
      this.canvas.height = 1;
    }

    this.canvas = null;
    this.ctx = null;

  }
}
